/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';

class Idle extends React.Component {

    constructor(props) {
        super();
        this.state = {

        };

        this.timeoutLogout = this.timeoutLogout.bind(this);
    }

    timeoutLogout(){
        setTimeout(() => { 
          window.location = '/depositapp';
        }, 200);
      }

    componentDidMount() {

    }

    render() {
        return (
            <div className="position-fixed IdleScreen d-flex align-items-center">
                <div className="idleContent d-flex justify-content-center align-items-center text-light">
                    <div className="text-center">
                        <h2>Session Timeout</h2>
                        <p>You're being timeout due to inactivity.</p>
                        <button className="btn btn-outline-light w-100 mt-3" onClick={this.timeoutLogout}>Ok</button>
                    </div>
                    
                </div>
            </div>

        );
    }
}


export default Idle;

